import {
  COURSE_LIST_REQUEST,
  COURSE_LIST_SUCCESS,
  COURSE_LIST_FAILURE,
  ADD_COURSE_REQUEST,
  ADD_COURSE_SUCCESS,
  ADD_COURSE_FAILURE,
  EDIT_COURSE_REQUEST,
  EDIT_COURSE_SUCCESS,
  EDIT_COURSE_FAILURE,
  DELETE_COURSE_REQUEST,
  DELETE_COURSE_SUCCESS,
  DELETE_COURSE_FAILURE,
  COURSE_BY_ID_REQUEST,
  COURSE_BY_ID_SUCCESS,
  COURSE_BY_ID_FAILURE,
  COURSE_MATERIAL_LIST_REQUEST,
  COURSE_MATERIAL_LIST_SUCCESS,
  COURSE_MATERIAL_LIST_FAILURE,
  ADD_COURSE_MATERIAL_REQUEST,
  ADD_COURSE_MATERIAL_SUCCESS,
  ADD_COURSE_MATERIAL_FAILURE,
  EDIT_COURSE_MATERIAL_REQUEST,
  EDIT_COURSE_MATERIAL_SUCCESS,
  EDIT_COURSE_MATERIAL_FAILURE,
  COURSE_MATERIAL_BY_ID_REQUEST,
  COURSE_MATERIAL_BY_ID_SUCCESS,
  COURSE_MATERIAL_BY_ID_FAILURE,
  DELETE_COURSE_MATERIAL_REQUEST,
  DELETE_COURSE_MATERIAL_SUCCESS,
  DELETE_COURSE_MATERIAL_FAILURE,
  GET_SCO_LIST_BY_COURSE_ID_REQUEST,
  GET_SCO_LIST_BY_COURSE_ID_SUCCESS,
  GET_SCO_LIST_BY_COURSE_ID_FAILURE,
  UPDATE_SCO_LIST_REQUEST,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE,
} from "./actionTypes";

import { CourseActions, CourseState } from "./types";

const initialState: CourseState = {
  pending: false,
  courseList: [],
  error: null,
  isCourseEdited: false,
};

const reducers = (state = initialState, action: CourseActions): unknown => {
  switch (action.type) {
    case COURSE_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COURSE_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        courseList: action.payload.courseList,
        error: null,
      };
    case COURSE_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ADD_COURSE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_COURSE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case ADD_COURSE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case EDIT_COURSE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case EDIT_COURSE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case EDIT_COURSE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case DELETE_COURSE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case DELETE_COURSE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case DELETE_COURSE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case COURSE_BY_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COURSE_BY_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        courseDetails: action.payload.courseDetails,
        error: null,
      };
    case COURSE_BY_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case COURSE_MATERIAL_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COURSE_MATERIAL_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        groupedCourseMaterialList: action.payload.groupedCourseMaterialList,
        error: null,
      };
    case COURSE_MATERIAL_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ADD_COURSE_MATERIAL_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_COURSE_MATERIAL_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case ADD_COURSE_MATERIAL_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case EDIT_COURSE_MATERIAL_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case EDIT_COURSE_MATERIAL_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case EDIT_COURSE_MATERIAL_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case COURSE_MATERIAL_BY_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case COURSE_MATERIAL_BY_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        courseMaterialDetails: action.payload.courseMaterialDetails,
        error: null,
      };
    case COURSE_MATERIAL_BY_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case DELETE_COURSE_MATERIAL_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case DELETE_COURSE_MATERIAL_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case DELETE_COURSE_MATERIAL_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_SCO_LIST_BY_COURSE_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_SCO_LIST_BY_COURSE_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
        courseOfferingList: action.payload.courseOfferingList,
      };
    case GET_SCO_LIST_BY_COURSE_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_SCO_LIST_REQUEST:
      return {
        ...state,
        pending: false,
        isCourseEdited: action.payload.isCourseEdited,
      };
    case PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS:
      return {
        ...state,
        pending: true,
        educators: action.payload.educators,
      };
    case PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE:
      return {
        ...state,
        pending: true,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducers;
